module.exports = __webpack_public_path__ + "media/icons/angel-white-759a1d15.png";